import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  questions: [],
  currentQuestion: null,
  isLoading: false,
  error: null,
};

const quizQuestionsSlice = createSlice({
  name: 'quizQuestions',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setQuestions: (state, action) => {
      state.questions = action.payload;
    },
    addQuestion: (state, action) => {
      state.questions.push(action.payload);
    },
    updateQuestion: (state, action) => {
      const index = state.questions.findIndex(q => q._id === action.payload._id);
      if (index !== -1) {
        state.questions[index] = action.payload;
      }
    },
    removeQuestion: (state, action) => {
      state.questions = state.questions.filter(q => q._id !== action.payload);
    },
    setCurrentQuestion: (state, action) => {
      state.currentQuestion = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  setLoading,
  setError,
  setQuestions,
  addQuestion,
  updateQuestion,
  removeQuestion,
  setCurrentQuestion,
  clearError,
} = quizQuestionsSlice.actions;

export default quizQuestionsSlice.reducer;

